export default {
    compoundIngredientCount: 2,
    compounds: [
        {productIdQlfr: "", productId: '', ingredientQty: ''},
        {productIdQlfr: "", productId: '', ingredientQty: ''}
    ],
    failedDrugList: [],
    requestType: 'New Request',
    numberRefills: '0',
    pregnantRadio: 'no',
    emergencyServices: 'no'
}